<template>
    <ModalBase :with-content="true" @close="closeModal">
        <form @submit.prevent="saveShade">
            <div class="modalContent">
                <Loader :loading="loading"></Loader>
                <h1 class="uppercase productShadeTitle">
                    {{ getDetails(this.$route.params.id).terms.name["en"]["value"] }} -
                    {{ getDetails(this.$route.params.id).terms.name["fr"]["value"] }}
                </h1>
                <h3>
                    {{ $t("product.launch") }}: {{ getDetails(this.$route.params.id).launchCampaign }}
                    <span v-if="getDetails(this.$route.params.id).discontinuedCampaign"
                        ><br />{{ $t("product.discontinued") }}: {{ getDetails(this.$route.params.id).discontinuedCampaign }}</span
                    >
                </h3>
                <table id="shadesTable" cellpadding="5" style="width: 100%;">
                    <tr>
                        <td width="30%" class="labelInput uppercase ff-medium">{{ $t("crudComponent.name") }}<sup>*</sup></td>
                        <td width="60%">
                            <input class="inputShades" type="text" v-model="newShade.name" style="width: 60%" />
                            <div v-if="isDuplicate.name.existed" v-html-safe="isDuplicate.name.message" v-bind:class="'duplicate-teinte'"></div>
                            <div v-if="!isShade.name.existed" v-html-safe="isShade.name.message" v-bind:class="'duplicate-teinte'"></div>
                        </td>
                    </tr>
                    <tr v-for="(n, index) in getShadesProperties" :key="index" class="propertiesShades" v-if="index !== 6">
                        <td class="labelInput uppercase ff-medium">{{ n.terms.name[$t("trad")] }} <span v-if="!!(index == 2)">*</span></td>
                        <td>
                            <input
                                class="inputShades"
                                v-on:mouseover="hoverColorInfo(index);"
                                type="text"
                                v-model="newShade.properties[index].value"
                                style="width: 60%"
                            />
                            <div
                                v-if="isDuplicate.ref.existed && !!(index == 2)"
                                v-html-safe="isDuplicate.ref.message"
                                v-bind:class="'duplicate-teinte'"
                            ></div>
                            <div
                                v-if="!isShade.ClientRef1.existed && !!(index == 2)"
                                v-html-safe="isShade.ClientRef1.message"
                                v-bind:class="'duplicate-teinte'"
                            ></div>
                            <div class="colors abs" :style="'background:' + newShade.properties[4].value + ';'" v-if="index === 4"></div>

                            <label for="" class="teinteCert rel" v-if="index === 4">
                                {{ $t("product.labelCertif") }} <input type="checkbox" id="zoneChecked" class="zoneChecked"
                            /></label>

                            <div v-if="index === 4 && showInfo === true" class="abs">Exemple: rgb(xxx,xxx,xxx) / #727A96</div>
                        </td>
                    </tr>
                </table>
            </div>
            <br />
            <div>
                <span class="labelInput uppercase ff-medium">{{ $t("product.labelLancement") }}</span>
                <select class="uppercase" name="" id="" v-model="product.campaigns.launch.id">
                    <option v-for="m in launchCampaign" :key="m.id" :value="m.id" :selected="m.id == product.campaigns.launch.id">
                        {{ m.name }}
                    </option>
                </select>
                <span class="labelInput uppercase ff-medium">{{ $t("product.labelDiscontinuer") }}</span>
                <select class="uppercase" name="" v-model="newShade.campaignDiscontinued.id">
                    <option class="uppercase" value="null" selected>Not discontinued</option>
                    <option v-for="m in discontinuedCampaign" :key="m.id" :value="m.id">{{ m.name }}</option>
                </select>
            </div>
            <br />
            <div>
                <h2 class="labelInput uppercase ff-medium">{{ $t("product.labelSelectZone") }}</h2>
                <div class="zone">
                    <table id="zoneTable" cellpadding="5">
                        <tr v-for="(m, key) in zoneList" :key="m.id">
                            <td>
                                <span class="labelInput uppercase ff-medium">{{ m.name }}</span>
                            </td>
                            <td><input type="checkbox" checked="true" @change="zoneChecked(m, $event);" class="zoneChecked" /></td>

                            <td>
                                <select
                                    class="uppercase"
                                    v-model="newShade.zones[key].campaignLaunch.id"
                                    @blur="campaignPerZone(newShade.zones[key].campaignLaunch.id);"
                                >
                                    <option
                                        v-for="m in launchCampaignPerZone"
                                        :value="m.id"
                                        :key="m.id"
                                        :selected="m.id == product.campaigns.launch.id"
                                        >{{ m.name }}
                                    </option>
                                </select>
                            </td>
                            <td>
                                <select class="uppercase" name="" v-model="newShade.zones[key].campaignDiscontinued.id">
                                    <option class="uppercase" value="null" selected>Not discontinued</option>
                                    <option v-for="m in discontinuedCampaignPerZone" :key="m.id" :value="m.id">{{ m.name }} </option>
                                </select>
                            </td>
                        </tr>
                    </table>
                </div>
            </div>
            <br />
            <div>
                <button class="btn block pointer center uppercase" type="submit">{{ $t("common.save") }}</button>
            </div>
        </form>
    </ModalBase>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import httpService from "../service";
import Spinner from "vue-simple-spinner";
import ModalBase from "@/components/modal/ModalBase";
import Loader from "@/components/loader/loader";

export default {
    data() {
        return {
            loading: null,
            showInfo: false,
            product: {
                campaigns: {
                    discontinued: null,
                    launch: {
                        id: null
                    },
                    standDesign: null
                }
            },
            zonesTmp: [],
            newShade: {
                visible: 1,
                toValidate: 1,
                isValidate: 0,
                active: 1,
                order: 1,
                name: "",
                campaign: {
                    id: null
                },
                campaignDiscontinued: {
                    id: null
                },
                properties: [
                    {
                        value: null
                    },
                    {
                        value: null
                    },
                    {
                        value: null
                    },
                    {
                        value: null
                    },
                    {
                        value: null
                    },
                    {
                        value: null
                    },
                    {
                        value: null
                    }
                ],
                zones: [],
                isCertified: null
            },
            campaignList: {},
            isShade: {
                ClientRef1: {
                    existed: true,
                    message: ""
                },
                name: {
                    existed: true,
                    message: ""
                }
            },
            zoneList: {},
            isDuplicate: {
                name: {
                    existed: false,
                    message: ""
                },
                ref: {
                    existed: false,
                    message: ""
                }
            },
            launchCampaignPerZone: null,
            discontinuedCampaignPerZone: null,
            launchCampaign: null,
            discontinuedCampaign: null,
            tmpTab: null
        };
    },
    components: {
        Spinner,
        ModalBase,
        Loader
    },
    watch: {
        "product.campaigns.launch.id"() {
            let tab = [];
            let launchDate = null;
            for (let launchId in this.launchCampaign) {
                if (this.launchCampaign[launchId].id === this.product.campaigns.launch.id) {
                    launchDate = this.launchCampaign[launchId].launchDate.date;
                }
            }
            for (let item in this.discontinuedCampaign) {
                if (this.discontinuedCampaign[item].launchDate.date > launchDate) {
                    tab.push(this.discontinuedCampaign[item]);
                }
            }
            this.discontinuedCampaign = tab;
        },
        product() {
            httpService.get("/admin/campaigns/list?limit=100").then(response => {
                this.campaignResponse = response.data;
                this.launchCampaign = this.campaignResponse;
                this.launchCampaignPerZone = this.campaignResponse;
                this.discontinuedCampaignPerZone = this.campaignResponse;
                this.discontinuedCampaign = this.campaignResponse;
                this.tmpTab = this.campaignResponse;
                this.campaignList = this.campaignResponse;
            });
        }
    },
    methods: {
        campaignPerZone(a) {
            let tab = [];
            let launchDate = null;
            for (let launchId in this.launchCampaign) {
                if (this.launchCampaign[launchId].id === a) {
                    launchDate = this.launchCampaign[launchId].launchDate.date;
                }
            }
            for (let item in this.discontinuedCampaign) {
                if (this.discontinuedCampaign[item].launchDate.date > launchDate) {
                    tab.push(this.discontinuedCampaign[item]);
                }
            }
            this.discontinuedCampaignPerZone = tab;
        },
        hoverColorInfo(key) {
            if (key === 4) {
                this.showInfo = !this.showInfo;
            }
        },
        closeModal() {
            this.$emit("hide");
        },
        zoneChecked(a, event) {
            let checked = event.target.checked;
            let zones = this.newShade.zones;
            let zone;
            for (let i in zones) {
                zone = zones[i];
                if (zone.zone.id === a.id) {
                    if (checked === false) {
                        this.zonesTmp.splice(this.zonesTmp.indexOf(zone), 1);
                    } else {
                        this.zonesTmp.push(zone);
                    }
                }
            }
        },
        checkShadeName() {
            this.isShade.name.existed = false;
            this.isShade.name.message = this.$t("shades.form.name");
            if (this.newShade.name !== "") {
                this.isShade.name.existed = true;
            }
        },
        checkShadeRef() {
            this.isShade.ClientRef1.existed = false;
            this.isShade.ClientRef1.message = this.$t("shades.form.ref1");
            this.newShade.properties.forEach(e => {
                if (e.propertyType.name === "client_ref1" && e.value !== "" && e.value !== null) {
                    this.isShade.ClientRef1.existed = true;
                    this.isShade.ClientRef1.message = "";
                }
            });
        },
        saveShade() {
            let self = this;
            this.checkShadeName();
            this.checkShadeRef();
            if (!this.isShade.ClientRef1.existed || !this.isShade.name.existed) {
                return;
            }
            this.newShade.zones = this.zonesTmp;
            this.newShade.campaign.id = this.product.campaigns.launch.id;
            this.newShade.isCertified = document.getElementById("zoneChecked").checked;
            this.loading = !this.loading;

            httpService.post("/admin/components/" + this.$route.params.id + "/shade", JSON.stringify(this.newShade)).then(response => {
                if (response.name || response.client_ref1) {
                    this.isDuplicate = {
                        name: {
                            existed: !!response.name,
                            message: "Ce nom existe déjà sur le produit"
                        },
                        ref: {
                            existed: !!response.client_ref1,
                            message: "Cette reference client existe déjà"
                        }
                    };
                    self.loading = false;
                } else {
                    self.loading = false;
                    location.reload();
                }
            });
        }
    },
    computed: {
        ...mapGetters({
            getDetails: "items/getDetails",
            getShadesProperties: "shade/getShadesProperties"
        })
    },
    created() {
        this.$store.dispatch("items/getDetails", { id: this.$route.params.id }).then(response => {
            if (response.code === 404) {
                this.product = "empty";
            } else {
                this.product = this.getDetails(this.$route.params.id);
            }
            httpService.get("/zones_accessbility/list?functionality=shade").then(response => {
                this.zoneList = response.data;
                for (let j in this.zoneList) {
                    let zonesObject = {
                        zone: {
                            id: this.zoneList[j].id
                        },
                        campaignLaunch: {
                            id: this.getDetails(this.$route.params.id).campaigns.launch.id
                        },
                        launchDate: null,
                        campaignDiscontinued: {
                            id: null
                        },
                        discontinuedDate: null
                    };
                    this.newShade.zones.push(zonesObject);
                    this.zonesTmp.push(zonesObject);
                }
            });
        });
        this.$store.dispatch("shade/getShadesProperties").then(response => {
            this.newShade.properties = [];
            for (let i in response) {
                let objectPropertyType = {
                    propertyType: {
                        id: response[i].id,
                        name: response[i].name
                    },
                    value: null
                };
                this.newShade.properties.push(objectPropertyType);
            }
        });
    }
};
</script>

<style lang="scss" scoped>
@import "../../assets/css/themes.scss";
.zone {
    overflow-y: scroll;
    height: 100px;
}
.teinteCert {
    padding-left: 60px;
}

.zoneChecked {
    margin-left: 2px;
}
#shadesTable {
    width: 40%;
}
.productShadeTitle {
    font-family: "Oswald", Sans-Serif;
}

.inputShades {
    font-size: 16px;
    border: none;
    border-bottom: 1px solid #333333;
}

.colors {
    height: 40px;
    width: 40px;
    border-radius: 50%;
    margin-top: -36px;
    margin-left: 351px;
}

.labelInput {
    margin-top: 2px;
    font-family: Roboto;
    font-weight: bold;
    font-size: 1.17em;
    padding-left: 20px;
    padding-right: 10px;
}

.duplicate-teinte {
    color: red;
    font-size: 12px;
    text-align: center;
    margin-left: 10px;
    display: inline-block;
    position: relative;
    top: 7px;
}
</style>



// WEBPACK FOOTER //
// CreateShade.vue?29c3d0b8